// Enhanced SpacerForm with Hero-style UI and Live Preview
import React, { useState } from 'react';
import { MoveVertical } from 'lucide-react';

const SpacerForm = ({ content, updateContent }) => {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-white flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
            <MoveVertical className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-2xl font-bold">Spacer Section</h2>
            <p className="text-indigo-100">Adjust spacing across devices</p>
          </div>
        </div>
        <button
          onClick={() => setShowPreview(!showPreview)}
          className="bg-white/20 hover:bg-white/30 transition-colors px-4 py-2 rounded-lg flex items-center gap-2"
        >
          {showPreview ? 'Hide' : 'Show'} Preview
        </button>
      </div>

      <div className="">
        <div className="flex-1 p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Desktop Height</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500"
              placeholder="2rem or 50px"
              value={content?.spacerHeight || '2rem'}
              onChange={(e) => updateContent('spacerHeight', e.target.value)}
            />
            <p className="text-xs text-gray-500 mt-1">
              Enter a value like "2rem" or "50px" to control the spacing height on desktop.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tablet Height</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500"
              placeholder="1.5rem or 30px"
              value={content?.tabletSpacerHeight || ''}
              onChange={(e) => updateContent('tabletSpacerHeight', e.target.value)}
            />
            <p className="text-xs text-gray-500 mt-1">
              Optional: Enter a different height for tablet devices. Defaults to desktop height if left empty.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Height</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500"
              placeholder="1rem or 20px"
              value={content?.mobileSpacerHeight || ''}
              onChange={(e) => updateContent('mobileSpacerHeight', e.target.value)}
            />
            <p className="text-xs text-gray-500 mt-1">
              Optional: Enter a different height for mobile devices. Defaults to desktop height if left empty.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Visibility</label>
            <div className="flex flex-col space-y-2">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox mr-2"
                  checked={!content?.hideOnDesktop}
                  onChange={(e) => updateContent('hideOnDesktop', !e.target.checked)}
                />
                <span className="text-sm">Show on desktop</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox mr-2"
                  checked={!content?.hideOnTablet}
                  onChange={(e) => updateContent('hideOnTablet', !e.target.checked)}
                />
                <span className="text-sm">Show on tablet</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox mr-2"
                  checked={!content?.hideOnMobile}
                  onChange={(e) => updateContent('hideOnMobile', !e.target.checked)}
                />
                <span className="text-sm">Show on mobile</span>
              </label>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Custom Classes</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500"
              placeholder="my-custom-spacer-class"
              value={content?.customClasses || ''}
              onChange={(e) => updateContent('customClasses', e.target.value)}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">ID</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500"
              placeholder="my-spacer-id"
              value={content?.id || ''}
              onChange={(e) => updateContent('id', e.target.value)}
            />
          </div>
        </div>

        {showPreview && (
          <div className="bg-gray-50 p-6 border-t border-gray-200">
            <div className="">
              <h3 className="font-bold text-lg mb-4 text-gray-800">Live Preview</h3>
              <div
                className={`rounded-xl shadow-inner bg-gradient-to-b from-gray-100 to-gray-200 flex items-center justify-center text-gray-500 text-sm`}
                style={{
                  height: content?.spacerHeight || '2rem',
                  display: content?.hideOnDesktop ? 'none' : 'flex'
                }}
              >
                Spacer ({content?.spacerHeight || '2rem'})
              </div>
              <p className="text-xs text-gray-500 mt-4 text-center">Desktop view of the spacer</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpacerForm;


// // src/components/admin/page-management/section-forms/SpacerForm.js
// import React from 'react';

// const SpacerForm = ({ content, updateContent }) => {
//   return (
//     <div>
//       <h3 className="font-bold text-lg mb-4">Spacer Section</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Desktop Height</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="2rem or 50px"
//           value={content?.spacerHeight || '2rem'}
//           onChange={(e) => updateContent('spacerHeight', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Enter a value like "2rem" or "50px" to control the spacing height on desktop.
//         </p>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Tablet Height</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="1.5rem or 30px"
//           value={content?.tabletSpacerHeight || ''}
//           onChange={(e) => updateContent('tabletSpacerHeight', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Optional: Enter a different height for tablet devices. Defaults to desktop height if left empty.
//         </p>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Mobile Height</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="1rem or 20px"
//           value={content?.mobileSpacerHeight || ''}
//           onChange={(e) => updateContent('mobileSpacerHeight', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Optional: Enter a different height for mobile devices. Defaults to desktop height if left empty.
//         </p>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Visibility</label>
//         <div className="flex flex-col space-y-2">
//           <label className="inline-flex items-center">
//             <input
//               type="checkbox"
//               className="form-checkbox mr-2"
//               checked={!content?.hideOnDesktop}
//               onChange={(e) => updateContent('hideOnDesktop', !e.target.checked)}
//             />
//             <span className="text-sm">Show on desktop</span>
//           </label>
//           <label className="inline-flex items-center">
//             <input
//               type="checkbox"
//               className="form-checkbox mr-2"
//               checked={!content?.hideOnTablet}
//               onChange={(e) => updateContent('hideOnTablet', !e.target.checked)}
//             />
//             <span className="text-sm">Show on tablet</span>
//           </label>
//           <label className="inline-flex items-center">
//             <input
//               type="checkbox"
//               className="form-checkbox mr-2"
//               checked={!content?.hideOnMobile}
//               onChange={(e) => updateContent('hideOnMobile', !e.target.checked)}
//             />
//             <span className="text-sm">Show on mobile</span>
//           </label>
//         </div>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Custom Classes</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="my-custom-spacer-class"
//           value={content?.customClasses || ''}
//           onChange={(e) => updateContent('customClasses', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Optional: Add custom CSS classes to the spacer.
//         </p>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">ID</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="my-spacer-id"
//           value={content?.id || ''}
//           onChange={(e) => updateContent('id', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Optional: Add an HTML ID to the spacer for linking or scripting.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default SpacerForm;





// // src/components/admin/page-management/section-forms/SpacerForm.js
// import React from 'react';

// const SpacerForm = ({ content, updateContent }) => {
//   return (
//     <div>
//       <h3 className="font-bold text-lg mb-4">Spacer Section</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Height</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="2rem or 50px"
//           value={content?.spacerHeight || '2rem'}
//           onChange={(e) => updateContent('spacerHeight', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Enter a value like "2rem" or "50px" to control the spacing height.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default SpacerForm;



